import "./ProductOverview.css";

const ProductOverview = () => {
  return (
    <section className="product-overview">
      <h1>Get the freedom you deserve.</h1>
    </section>
  );
};

export default ProductOverview;
